var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common-share" }, [
    _c("img", { staticClass: "img", attrs: { src: require("./imgs/bg.png") } }),
    _c(
      "div",
      { staticClass: "bottom-box" },
      [
        _vm._m(0),
        _vm._m(1),
        _c("notice"),
        _c("div", { staticClass: "button-wrp" }, [
          _c("img", {
            staticClass: "btn",
            attrs: { src: require("./imgs/btn.png"), alt: "" },
            on: { click: _vm.to }
          })
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-img" }, [
      _c("span", { staticClass: "share_text1" }, [
        _vm._v("完成注册认证后可领取4.9元红包")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-img" }, [
      _c("span", { staticClass: "share_text2" }, [
        _vm._v("邀请1人认证，可再次领取4.9元红包")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }